<ng-content></ng-content>
@if (show) {
  <div [class]="cssClass">
    {{ message }}
  </div>
}
